package com.yendo.mx.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.WifiOff
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.foundation.BorderStroke
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.yendo.mx.ui.theme.RosaYendo
import io.github.alexzhirkevich.compottie.Compottie
import io.github.alexzhirkevich.compottie.LottieCompositionSpec
import io.github.alexzhirkevich.compottie.rememberLottieComposition
import io.github.alexzhirkevich.compottie.rememberLottiePainter
import org.jetbrains.compose.resources.ExperimentalResourceApi
import yendo.shared.generated.resources.Res

@OptIn(ExperimentalResourceApi::class)
@Composable
fun SinConexionScreen() {
    val composition by rememberLottieComposition {
        LottieCompositionSpec.JsonString(
            Res.readBytes("files/error.json").decodeToString()
        )
    }

    val isDark = androidx.compose.foundation.isSystemInDarkTheme()
    val colorFondo = if (isDark) Color(0xFF121212) else Color.White
    val colorTextoSecundario = if (isDark) Color(0xFFAAAAAA) else Color.Gray

    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(colorFondo),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            modifier = Modifier
                .fillMaxWidth()
                .padding(32.dp)
        ) {
            // 🚀 ANIMACIÓN
            val painter = rememberLottiePainter(
                composition = composition,
                iterations = Compottie.IterateForever
            )
            Image(
                painter = painter,
                contentDescription = "Sin conexión",
                modifier = Modifier.size(220.dp)
            )

            Spacer(modifier = Modifier.height(12.dp))

            // 🚀 TÍTULO Y MENSAJE
            Text(
                text = "¡Ups! Te desconectaste",
                fontSize = 24.sp,
                fontWeight = FontWeight.Black,
                color = RosaYendo,
                textAlign = TextAlign.Center
            )

            Spacer(modifier = Modifier.height(12.dp))

            Text(
                text = "Necesitamos internet para poder llevarte lo que quieras. Revisa tu Wi-Fi o datos móviles.",
                fontSize = 15.sp,
                color = colorTextoSecundario,
                textAlign = TextAlign.Center,
                lineHeight = 22.sp
            )

            Spacer(modifier = Modifier.height(40.dp))

            // 🚀 INDICADOR VISUAL (No interactivo)
            Surface(
                color = RosaYendo,
                shape = RoundedCornerShape(16.dp),
                modifier = Modifier
                    .fillMaxWidth()
                    .height(56.dp)
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {
                    CircularProgressIndicator(
                        color = Color.White,
                        modifier = Modifier.size(18.dp),
                        strokeWidth = 2.dp
                    )
                    Spacer(Modifier.width(12.dp))
                    Text(
                        "Buscando señal...", 
                        fontWeight = FontWeight.Bold,
                        fontSize = 16.sp,
                        color = Color.White
                    )
                }
            }
        }
        
        // MARCA AGUA SUTIL AL FINAL
        androidx.compose.material3.Text(
            text = "YENDO MX",
            modifier = Modifier
                .align(Alignment.BottomCenter)
                .padding(bottom = 32.dp),
            style = androidx.compose.ui.text.TextStyle(
                color = colorTextoSecundario.copy(alpha = 0.3f),
                fontWeight = FontWeight.Black,
                letterSpacing = 4.sp,
                fontSize = 12.sp
            )
        )
    }
}
